import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const InputDateContainer = styled.div`
  width: 100%;
`;

export const InputDateGroup = styled.div`
  border-radius: 8px;
  border: 1px solid ${colors.textSecondary};
  display: flex;
  width: 100%;
  align-items: center;
  position: relative;
  background:  ${colors.white};

  &[readOnly] {
    background: ${colors.readOnlyBorder};
    border: 1px solid ${colors.readOnlyBorder};
  }
  
  &.error {
    border-bottom: solid 5px  ${colors.bgDanger}; 
  }

  svg {
    margin-right: 8px;
    position: absolute;
    right: 5px;
    z-index: 1;
  }
`;

export const InputDateLabel = styled.label`
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.03em;
  color:  ${colors.textPrimary};
  opacity: 0.9;
  text-transform: uppercase;
  margin-bottom: 12px;
  display: block;
`;

export const InputDateField = styled.input`
  width: 100%;
  background: transparent;
  border: 0;
  font-size: 14px;
  position: relative;
  color:  ${colors.textPrimary};
  position: relative;
  font-family: 'Montserrat', sans-serif;
  padding: 10px;
  transition: ease-in-out .2s;
  height: 44px;

  &:read-only {
    background: ${colors.readOnlyBorder};
    border: 1px solid ${colors.readOnlyBorder};
  }

  ::-webkit-calendar-picker-indicator {
    opacity: 0;
    position: relative;
    z-index: 5;
    outline: 0;
    cursor: pointer !important;
  }
`;

export const InputDateMessageError = styled.small`
  font-size: 12px;
  color: ${colors.bgDanger};
  line-height: 14px;
  margin: 5px 8px;
  opacity: ${prop => prop.error ? '1' : '0'};
  transition: ease-in-out .2s;
`;
